import { Validator } from "./validator";

const ITEM_CODE = {
  EMAIL: "01",
  PASSWORD: "02",
};

class SignInValidator extends Validator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();
    this.errors.email = [];
    this.errors.password = [];
  }
  /* eslint-enable */

  static validate(email, password) {
    const validator = new SignInValidator();

    // メールアドレス
    validator.checkEmail(
      "email",
      email,
      "メールアドレス",
      ITEM_CODE.EMAIL,
    );

    // パスワード
    validator.checkText("password", password, "パスワード", ITEM_CODE.PASSWORD, {
      required: true,
    });

    return validator;
  }
}

export {
  SignInValidator,
};
